<app-button
    *ngIf="fileExists"
    (buttonClick)="onClick()"
    [icon]="'fa-download'"
    [type]="'icon'"
    [tooltip]="'Download'"
>
</app-button>
<app-button
    *ngIf="!fileExists"
    [icon]="'fa-times-circle'"
    [type]="'icon'"
    [disabled]="true"
>
</app-button>
